module.exports = __webpack_public_path__ + "static/pink-square-ef2e44e2d122d1ae4146e2dd8ec83e76.png";